import { render, staticRenderFns } from "./BaseResComplex.vue?vue&type=template&id=e5e37108&scoped=true"
import script from "./BaseResComplex.vue?vue&type=script&lang=js"
export * from "./BaseResComplex.vue?vue&type=script&lang=js"
import style0 from "./BaseResComplex.vue?vue&type=style&index=0&id=e5e37108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e37108",
  null
  
)

export default component.exports